import Text from './Text';
import * as React from 'react';
export const Caption = (props) => {
    const { children, ...otherProps } = props;
    return (React.createElement(Text, Object.assign({ type: "caption" }, otherProps), children));
};
Caption.displayName = 'Caption';
export default Caption;
//# sourceMappingURL=Caption.js.map